<template>
  <div class="page">
    <div v-if="tag" :class="tag.Codice">
      <h1 class="title title--page">
        {{tag.Descrizione}} <br>
        <app-category :color="tag.Colore"></app-category>
        <!--<span class="d-inline-block ico-cat" :class="'ico-cat--'+tag.Codice"></span>-->
      </h1>
    </div>

    <div v-if="query" class="text-center [ pb-2 ]">
      Hai cercato:
      <strong>{{query}}</strong>
    </div>
    <div class="col-12" v-if="!loaded">
      <em>Caricamento in corso...</em>
    </div>
    <div v-if="events.length==0 && loaded" class="text-center">
      Nessun evento trovato
    </div>

    <div class="row [ mx-0 ]">

      <div v-for="(event,i) in events" :key="i" class="col-12 col-lg-6 [ px-0 pb-5 ] ">
        <div class="row [ mx-0 ]">
          <div class="col-5 [ pl-0 ]">
            <img :src="getImageUrl(event.immagine)" class="img-fluid img-fit" alt="">
          </div>
          <div class="col-7 [ pl-0 ]">
            <h2 class="subtitle [ border-bottom ]">
              {{event.titolo}}
              <span v-if="event && event.esaurito" class="text-size-12  badge badge-primary">SOLD OUT</span>
            </h2>
            <div class="row">
              <div v-if="event.eventoLuoghi && event.eventoLuoghi.length>0" class="col-12">
                <div class="d-flex align-items-center">
                  <div class="pr-1 svg" :class="`svg--${tagEvento(event).Codice}`">
                    <app-marker :color="tagEvento(event).Colore"></app-marker>
                  </div>
                  <div>
                    <p class="text-mini [ text-uppercase ]">{{event.eventoLuoghi[0].Descrizione}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="d-flex align-items-center [ pt-1 ]">
                  <div class="pr-1">
                    <img src="../../assets/ico-calendar.svg" alt="">
                  </div>
                  <div>
                    <p class="text-mini [ text-uppercase ]">
                      Da {{event.inizio | formatDate}}<br>
                      a {{event.fine | formatDate}}
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="text-size-14 [ mt-3 ]" v-html="event.eventoDescrizioneBreve"></div>

            <router-link :to="'/evento/'+event.slug" v-if="event.slug" class="text-uppercase text-weight-600 text-size-12" :class="`text-${tagEvento(event).Codice}`">
              Scopri il programma e prenota &#8594;
            </router-link>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapActions } from 'vuex'

moment.locale('it')

export default {
  components: {

  },
  mounted () {
    // var me = this
    // console.log("params", this.$route.params)
    // this.$store.dispatch('event/events', { tag: me.$route.params.tag || 'all', q: '', start: '', end: '' });

  },
  computed: {
    loaded () {
      return this.$store.state.event.loaded
    },

    events () {
      // this.$store.dispatch('course/courses', { start: this.$store.state.course.selectedWeek.start, end: this.$store.state.course.selectedWeek.end, level: this.$store.state.course.selectedLevel.courseLevelId } );
      var me = this
      if (this.$store.state.event.events.length == 0 && !this.$store.state.event.loaded) {
        this.$store.dispatch('event/events', { tag: me.$route.params.tag || 'all', q: me.$route.query.q || '', start: me.$route.query.start || new moment().format('YYYY-MM-DD'), end: me.$route.query.end || '9999-01-01' })
      }
      return this.$store.state.event.events
    },
    query () {
      return this.$route.query.q
    },
    tag () {
      if (this.$store.state.event) {
        for (var j = 0; j < this.$store.state.event.tags.length; j++) {
          if (this.$store.state.event.tags[j].Codice == this.$route.params.tag) {
            return this.$store.state.event.tags[j]
          }
        }
      }
    }
  },
  methods: {
    getImageUrl (image) {
      return window.base_image_url + image + '?width=250'
    },
    tagEvento (event) {
      if (event && this.$store.state.event && event.eventoTags) {
        for (var i = 0; i < event.eventoTags.length; i++) {
          for (var j = 0; j < this.$store.state.event.tags.length; j++) {
            if (this.$store.state.event.tags[j].Codice == event.eventoTags[i].Codice) {
              return this.$store.state.event.tags[j]
            }
          }
        }
        return this.$store.state.event.tags[0]
      }
    }
  },
  // beforeRouteUpdate(to, from, next) {

  //  var me = this
  //  // react to route changes...
  //  this.$store.dispatch('event/clearEvents');
  //  // don't forget to call next()
  //  next();
  // },
  created () {
    // var me = this

    // this.$store.dispatch('event/tags').then(response => {
    //  this.$store.dispatch('event/events', { tag: me.$route.params.tag || 'all', q: me.$route.query.q || '', start: '', end: '' });
    // })
  }

}
</script>
